// @ts-strict-ignore
import { StyledTextProps, allStyledSystemFunctions } from './config'
import { breakpoints } from '@gassan-ui'
import shouldForwardProp from '@styled-system/should-forward-prop'
import { darken, rem } from 'polished'
import React, { FC, HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

const defaultStyles = css`
  font-family: Helvetica, sans-serif;
  vertical-align: baseline;
  white-space: pre-line;
  font-weight: 300;
  line-height: 1.6;
  color: ${(p) => p.theme.rolex.colors.shades[900]};
  a {
    transition: color 0.2s ease-in-out;
    &:hover,
    &:focus {
      color: ${(p) => darken(0.2, p.theme.rolex.colors.primary)};
    }
  }
`

export const buttonLabel = css`
  ${defaultStyles};
  font-size: ${rem(14)};
  @media screen and (min-width: ${breakpoints.medium}) {
    font-size: 1rem;
  }
`

export const regular = css`
  ${defaultStyles};
  font-size: 1rem;
  line-height: 1.8;
`

const sectionTitle = css`
  ${defaultStyles};
  font-size: 0.75rem;
  font-weight: 500;
  @media screen and (min-width: ${breakpoints.medium}) {
    font-size: ${rem(14)};
  }
`

export const description = css`
  ${defaultStyles};
  font-size: 0.75rem;
  @media screen and (min-width: ${breakpoints.medium}) {
    font-size: ${rem(14)};
  }
`

export const smallDescription = css`
  ${defaultStyles};
  font-size: ${rem(11)};
  @media screen and (min-width: ${breakpoints.medium}) {
    font-size: 0.75rem;
  }
`

const textStyles = {
  regular,
  description,
  smallDescription,
  sectionTitle,
  buttonLabel,
}

export type TextProps = HTMLAttributes<HTMLParamElement> &
  StyledTextProps & {
    variant?: keyof typeof textStyles
    dangerouslySetInnerHTML?: {
      __html: string
    }
  }

export const Text: FC<TextProps> = styled<React.FC<TextProps>>(
  React.forwardRef((props: TextProps, ref: any) => {
    let As = props.as || 'p'
    return <As {...props} ref={ref}></As>
  }),
).withConfig({ shouldForwardProp })(
  (props) => props.variant && textStyles[props.variant],
  allStyledSystemFunctions,
)

Text.defaultProps = {
  variant: 'regular',
}
